import { KC_DCM_TOKEN_URL } from '@custom/constant';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const kcDcmTokenApi = createAsyncThunk(
  'kcDcmToken',
  async (payload: URLSearchParams, { rejectWithValue }) => {
    try {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: payload,
      };
      const res = await fetch(KC_DCM_TOKEN_URL, requestOptions);

      // Check if the response is not okay (status is 400 or other errors)
      if (!res.ok) {
        const errorData = await res?.json(); // Extract error message from the res
        return rejectWithValue(errorData?.error_description || 'Error in PACS authorization');
      }

      const data = await res.json();

      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
